import { Injectable } from "@angular/core";
import { API_URL, OperationType } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../../base-data-services/data.service";
import { mentorLogs } from "common/models/page-models/student-details/student-details-model";
import { environment } from "src/environments/environment";


@Injectable()
export class mentorLogsDataService extends DataService<mentorLogs> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.studentMentoringLogs,http);
    }


//     getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
    
    createInstance():mentorLogs  {
        return new mentorLogs();
    }


    override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
        return environment.apiUrl + this.getAPI_URL();
      }
}
